/*
 * PDP sticky wishlist heart: hide it once the gallery has scrolled past, so the
 * sticky heart doesn't overshoot into the section below the images.
 *
 * The heart (.product__wishlist-sticky) is CSS-sticky below the header. Its
 * containing block (.product__media-wrapper) is taller than the images in the
 * 2-col layout, so plain sticky overshoots. Here we hide the heart when the
 * gallery's bottom edge rises above the heart's stuck position, and show it
 * again on the way back up.
 */
(function () {
  function init() {
    var sticky = document.querySelector('.product__wishlist-sticky');
    var gallery = document.querySelector('media-gallery');
    if (!sticky || !gallery) return;

    // Where the heart sticks: top of viewport + header clearance + the button's
    // own rest offset. Read the computed sticky top so it tracks the CSS value.
    function stickTop() {
      var top = parseFloat(getComputedStyle(sticky).top) || 0; // header clearance
      var btn = sticky.querySelector('.product__wishlist-toggle');
      var btnTop = btn ? (parseFloat(getComputedStyle(btn).top) || 0) : 0;
      return top + btnTop;
    }

    // Hide this many px BEFORE the gallery bottom reaches the heart's stuck
    // line, so the heart disappears sooner (while some gallery is still visible).
    // Increase to hide earlier, decrease (or 0) to hide later.
    var EARLY_HIDE_PX = 150;

    var ticking = false;
    function update() {
      ticking = false;
      var galleryBottom = gallery.getBoundingClientRect().bottom;
      // Hide once the gallery bottom approaches the heart's stuck line.
      var pastGallery = galleryBottom <= stickTop() + EARLY_HIDE_PX;
      sticky.classList.toggle('is-past-gallery', pastGallery);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
